<div class="sidebar-filters-content collapse-icon">
  <div class="collapse-default">
    <div class="card">
      <div class="card-header d-flex align-items-center"
           (click)="isCollapsed = !isCollapsed"
           [attr.aria-expanded]="!isCollapsed"
           aria-controls="collapseLocationExample"
           data-toggle="collapse"
           role="button">
        <div class="row collapse-title btn p-0">
          <h6 class="mb-0">{{ 'BENEFITS_FILTER.LOCATION' | translate }}</h6>
        </div>
      </div>

      <div [ngbCollapse]="isCollapsed" id="collapseLocationExample">
        <div class="card">
          <div class="card-body p-0" [ngStyle]="!isMobile ? {'max-height': '300px', 'overflow-y': 'auto'} : null">
            <div class="categories-list">
              <div class="category-item" *ngFor="let county of counties">
                <div class="custom-control custom-checkbox">
                  <input type="checkbox"
                         class="custom-control-input"
                         [id]="'county-' + county"
                         [(ngModel)]="locationSelection[county]"
                         (change)="checkLocation()"/>
                  <label class="custom-control-label" [for]="'county-' + county">
                    {{ CountyLabel[county] | translate }}
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
